export default __webpack_public_path__ + "static/media/imcommunity_wall_logo.4ebb81cd.png";